(() => {
  const MOBILE_QUERY = window.matchMedia('(max-width: 767px)');
  const ROOT = document.documentElement;
  const HIDE_CLASS = 'm-hide-floating-buttons';

  const observed = new WeakSet();
  const observers = [];

  const getMenuDrawer = () => document.querySelector('#m-menu-drawer');
  const getHeaderMobile = () => document.querySelector('.m-header__mobile');
  const getCartDrawer = () => document.querySelector('m-cart-drawer');

  const isMenuOpen = () => {
    const menuDrawer = getMenuDrawer();
    const headerMobile = getHeaderMobile();
    return (
      (menuDrawer && menuDrawer.classList.contains('open')) ||
      (headerMobile && headerMobile.classList.contains('header-drawer-open'))
    );
  };

  const isCartOpen = () => {
    const cartDrawer = getCartDrawer();
    return cartDrawer && cartDrawer.classList.contains('m-cart-drawer--active');
  };

  const update = () => {
    if (!MOBILE_QUERY.matches) {
      ROOT.classList.remove(HIDE_CLASS);
      return;
    }

    const shouldHide = isMenuOpen() || isCartOpen();
    ROOT.classList.toggle(HIDE_CLASS, Boolean(shouldHide));
  };

  const observeClassChanges = (el) => {
    if (!el || observed.has(el)) return;
    observed.add(el);

    const mo = new MutationObserver(() => update());
    mo.observe(el, { attributes: true, attributeFilter: ['class'] });
    observers.push(mo);
  };

  const refreshObservers = () => {
    if (!MOBILE_QUERY.matches) return;
    observeClassChanges(getMenuDrawer());
    observeClassChanges(getHeaderMobile());
    observeClassChanges(getCartDrawer());
  };

  const setup = () => {
    refreshObservers();
    update();
  };

  const onMobileChange = () => {
    setup();
  };

  if (MOBILE_QUERY.addEventListener) {
    MOBILE_QUERY.addEventListener('change', onMobileChange);
  } else if (MOBILE_QUERY.addListener) {
    MOBILE_QUERY.addListener(onMobileChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  // If drawers are injected late by apps/sections, keep observers up-to-date.
  const domMo = new MutationObserver(() => {
    refreshObservers();
    update();
  });
  domMo.observe(document.documentElement, { childList: true, subtree: true });
})();
